import React from 'react';
import './Header.css';
import SearchIcon from '@mui/icons-material/Search';
import HeaderOption from './HeaderOption';
import HomeIcon from '@mui/icons-material/Home';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ChatIcon from '@mui/icons-material/Chat';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useDispatch } from 'react-redux';
import { auth } from './firebase';
import { logout } from './features/userSlice';
import { useNavigate } from 'react-router-dom';  

function Header() {
   const dispatch = useDispatch();
   const navigate = useNavigate(); 
   const logoutOfApp = () => {
  auth.signOut()
    .then(() => {
      dispatch(logout());
      navigate('/login');
    })
    .catch((error) => {
      console.error('Logout error:', error);
    });
}


  return (
    <div className='header'>
        <div className='header_left'>
            <img src='https://www.svgrepo.com/show/157006/linkedin.svg' alt='' />
            <div className='header_search'>
                <SearchIcon />
                <input type='text' />
            </div>
        </div>
        <div className='header_right'>
            <HeaderOption Icon={HomeIcon} title='Home' />
            <HeaderOption Icon={SupervisorAccountIcon} title='My Network' />
            <HeaderOption Icon={BusinessCenterIcon} title='Jobs' />
            <HeaderOption Icon={ChatIcon} title='Messaging' />
            <HeaderOption Icon={NotificationsIcon} title='Notifications' />
            <HeaderOption avatar={true} title='me' onClick={logoutOfApp} />
        </div>
    </div>
  )
}

export default Header;
